export const GET_AFFILIATE_REQUEST = "GET_AFFILIATE_REQUEST";
export const ACCEPT_AFFILIATE_REQUEST = "ACCEPT_AFFILIATE_REQUEST";
export const REJECT_AFFILIATE_REQUEST = "REJECT_AFFILIATE_REQUEST";